import * as Yup from 'yup'

export const INITIAL_VALUES = {
  firstName: '',
  lastName: '',
  email: '',
  subject: '',
  phonePrefix: '',
  phone: '',
  companyName: '',
  province: '',
  jobTitle: '',
  targetIndustry: '',
  interestedIn: '',
  existingCustomer: '',
  privacy: false,
}

export function buildValidationSchema(t: (key: string) => string) {
  return Yup.object().shape({
    firstName: Yup.string().required(t('composableForm.errorRequired')),
    lastName: Yup.string().required(t('composableForm.errorRequired')),
    email: Yup.string()
      .email(t('composableForm.errorEmail'))
      .required(t('composableForm.errorRequired')),
    subject: Yup.string().required(t('composableForm.errorRequired')),
    phonePrefix: Yup.string().required(t('composableForm.errorRequired')),
    phone: Yup.string()
      .matches(/^[0-9+\s]*$/, t('composableForm.errorNumber'))
      .required(t('composableForm.errorRequired')),
    companyName: Yup.string().required(t('composableForm.errorRequired')),
    province: Yup.string().required(t('composableForm.errorRequired')),
    jobTitle: Yup.string(),
    targetIndustry: Yup.string().required(t('composableForm.errorRequired')),
    interestedIn: Yup.string(),
    existingCustomer: Yup.string().required(t('composableForm.errorRequired')),
    privacy: Yup.boolean().oneOf([true], t('composableForm.errorPrivacy')),
  })
}

export const STEP_FIELDS: Record<number, string[]> = {
  0: ['firstName', 'lastName', 'email', 'subject', 'phonePrefix', 'phone'],
  1: ['companyName', 'province', 'jobTitle', 'targetIndustry'],
  2: ['interestedIn', 'existingCustomer'],
}
